import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import { providePrimeNG } from 'primeng/config';

// import { config } from '@fortawesome/fontawesome-svg-core';
// import '@fortawesome/fontawesome-svg-core/styles.css';

// config.autoAddCss = false;

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
